import { __assign, __rest } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import HiddenLayout from './HiddenLayout';
import Blocked from './Icons/Blocked';
var DefaultBlockedOverlay = function (_a) {
    var deviation = _a.deviation, props = __rest(_a, ["deviation"]);
    var t = useTranslation().t;
    return (React.createElement(HiddenLayout, __assign({ deviation: deviation, icon: React.createElement(Blocked, null), title: t('deviationview.blocked.default') }, props)));
};
DefaultBlockedOverlay.displayName = 'DefaultBlockedOverlay';
export default DefaultBlockedOverlay;
//# sourceMappingURL=DefaultBlocked.js.map